import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import renderRichText from '../../utils/renderRichText';

const Others = () => {
  const data = useStaticQuery(graphql`
    {
      contentfulOneOhOne(title: { eq: "Other Drugs" }) {
        paragraph2 {
          raw
        }
      }
    }
  `);

  const { contentfulOneOhOne } = data;
  const paragraph2 = JSON.parse(contentfulOneOhOne.paragraph2.raw);

  return (
    <section className="section">
      <div className="content">
        <div className="container container-block">
          <div
            id="Signs & Symptoms of Addiction"
            style={{ scrollMarginTop: '6.5rem' }}
          >
            <h2 className="is-size-2">Signs and Symptoms of Addiction</h2>
            {renderRichText(paragraph2)}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Others;
